<mat-toolbar color="primary">Ovie Health — {{ practiceName }}</mat-toolbar>

<mat-dialog-content class="min-h-[160px]">
  <div class="flex flex-col gap-4 p-4">
    <mat-slide-toggle
      [checked]="enabled()"
      [disabled]="saving()"
      (change)="toggleEnabled($event.checked)"
    >
      Enable AI Receptionist
    </mat-slide-toggle>

    <mat-slide-toggle
      [checked]="testModeEnabled()"
      [disabled]="saving()"
      (change)="toggleTestMode($event.checked)"
    >
      Test mode
    </mat-slide-toggle>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    type="button"
    mat-button
    mat-dialog-close
    [disabled]="saving() || fetching()"
  >
    Close
  </button>
  <button
    type="button"
    mat-flat-button
    color="primary"
    [disabled]="fetching()"
    (click)="viewRawData()"
  >
    @if (fetching()) {
      <mat-spinner class="mr-2 inline-block" diameter="18" />
    }
    View raw data
  </button>
</mat-dialog-actions>
